import {
  LocationProvider,
  Router,
  Route,
  hydrate,
  prerender as ssr,
} from "preact-iso";

import { Header } from './components/Header/Header.js';
import Home from './pages/Home/index.js';
import { NotFound } from './pages/_404.jsx';
import { initializeApp } from 'firebase/app';
import './style.css';
import LoginComponent from './pages/Login/Login.js';
import Business from "./components/Businesses/BusinessComponent.js";
import CategoryComponent from "./components/Categories/Category.tsx";
import { Testimonials } from "./components/Testimonials/Testimonials.jsx";
import SearchComponent from "./components/Search/Search.js";
import CategoriesPage from "./components/Categories/CategoriesPage.js";
import { AppDownloadBanner } from "./components/AppDownloadBanner/AppDownloadBanner.js";
import { Footer } from "./components/Footer/Footer.js";

export function App() {
	try {
		const cfg = import.meta.env.VITE_FIREBASE_CONFIG;
		if (cfg) initializeApp(JSON.parse(cfg as string));
	} catch (e) {
		// Firebase init is only required by the Login page; swallow errors so
		// the rest of the site renders cleanly when dev uses a dummy config.
	}

	return (
		<LocationProvider>
			<Header />
			<main>
				<Router>
					<Route path="/" component={Home} />
					<Route path="/business/:companyID" component={Business} />
					<Route path="/categories" component={CategoriesPage} />
					<Route path="/category/:categoryID" component={CategoryComponent} />
					<Route path="/login" component={LoginComponent} />
					<Route path="/search/:query" component={SearchComponent} />
					<Route default component={NotFound} />
				</Router>
			</main>
			<Testimonials />
			<Footer />
			<AppDownloadBanner />
		</LocationProvider>
	);
}

if (typeof window !== "undefined") {
  hydrate(<App />, document.getElementById("app"));
}

export async function prerender(data) {
  return await ssr(<App {...data} />);
}
